<script setup>
import { useAuthStore } from '@/stores/auth'
import { RouterView } from 'vue-router'
import TheHeader from './components/TheHeader.vue'
import { usePwaUpdater } from '@/composables/usePwaUpdater'
import { SwalDelete } from './helpers/mySwal'
import { watch } from 'vue'

const authStore = useAuthStore()
const { updateAvailable, triggerUpdate } = usePwaUpdater()

// פופאפ כשיש עדכון
watch(updateAvailable, async (val) => {
  if (val) {
    const res = await SwalDelete.fire({
      title: '🎉 גרסה חדשה זמינה',
      text: 'האם ברצונך לעדכן עכשיו?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'עדכן',
      cancelButtonText: 'מאוחר יותר'
    })

    if (res.isConfirmed) {
      triggerUpdate()
    }
  }
})

window.addEventListener('pwa-update-available', () => {
  updateAvailable.value = true
})
</script>

<template>
  <div class="bg-surface-100 text-primary flex h-full flex-col overflow-hidden lg:flex-row">
    <TheHeader v-if="authStore.isAuthenticated" />
    <div class="fixed top-0 left-1 z-50 text-xs opacity-30">גרסה 1.7.1</div>
    <main
      class="h-full w-full overflow-hidden px-0 pt-4 md:px-4 lg:h-screen lg:px-8 lg:pt-8 lg:pb-4"
    >
      <RouterView />
    </main>
  </div>
</template>

<style>
/* בקובץ ה-CSS הגלובלי שלך או בתג <style> בקומפוננט הראשי */
.vuecal {
  --vuecal-primary-color: var(--p-primary-color) !important;
}
</style>
